// ---------------------------------------------------------------------------
// Request timeout configuration (seconds)
// ---------------------------------------------------------------------------

const isProd = process.env.NODE_ENV === 'production'

// Default timeout for all API requests
export const DEFAULT_TIMEOUT = isProd ? 30 : 60

// Checkout-related requests get more headroom
export const CHECKOUT_TIMEOUT = isProd ? 60 : 90
